module.exports = __webpack_public_path__ + "helveticaltstd-roman-webfont.c8c2de44035cbfc16876.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/helveticaltstd-roman-webfont.ttf
// module id = ../../../../../src/assets/fonts/helveticaltstd-roman-webfont.ttf
// module chunks = styles